import { render, staticRenderFns } from "./teamPage.vue?vue&type=template&id=706710a7&scoped=true&"
import script from "./teamPage.vue?vue&type=script&lang=js&"
export * from "./teamPage.vue?vue&type=script&lang=js&"
import style0 from "./teamPage.vue?vue&type=style&index=0&id=706710a7&scoped=true&lang=css&"
import style1 from "./teamPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706710a7",
  null
  
)

export default component.exports